import React from "react";
import classNames from "classnames";

const OpenCloseItem = (props) => {
    const {onClick, isOpen} = props;
    return (
        <div className={"arag"}>
            <button
                onClick={onClick}
                className={
                    classNames(
                        "btn-primary",
                        "btn-open-close",
                        isOpen ? "btn-is-closed" : ""
                    )
                }
                type={"button"}
            >
            </button>
        </div>
    )
};

export default OpenCloseItem;